// Environment and global configuration for WordPress credentials
// Reads Vite env (VITE_*) and exposes a helper. Also supports a global override via window.WP_BACKOFFICE_CONFIG.

export const getEnvConfig = () => {
  const env = typeof import.meta !== 'undefined' ? import.meta.env || {} : {};
  const envCfg = {
    wpUrl: env.VITE_WP_URL || '',
    username: env.VITE_WP_USERNAME || '',
    password: env.VITE_WP_PASSWORD || '',
    loginUser: env.VITE_LOGIN_USER || '',
    loginPassword: env.VITE_LOGIN_PASSWORD || '',
    apiBaseUrl: env.VITE_API_BASE_URL || '',
  };
  const globalCfg = typeof window !== 'undefined' && window.WP_BACKOFFICE_CONFIG
    ? window.WP_BACKOFFICE_CONFIG
    : {};
  // Precedence: global overrides env
  return {
    ...envCfg,
    ...globalCfg,
    // Allow dedicated app login config (window.APP_LOGIN_CONFIG)
    ...(typeof window !== 'undefined' && window.APP_LOGIN_CONFIG ? {
      loginUser: window.APP_LOGIN_CONFIG.user || envCfg.loginUser,
      loginPassword: window.APP_LOGIN_CONFIG.password || envCfg.loginPassword,
    } : {}),
    ...(typeof window !== 'undefined' && window.RUNTIME_CONFIG ? {
      apiBaseUrl: window.RUNTIME_CONFIG.apiBaseUrl || envCfg.apiBaseUrl,
    } : {}),
  };
};

// Bootstrap a global config if none set, to allow overriding at runtime if needed.
if (typeof window !== 'undefined') {
  window.WP_BACKOFFICE_CONFIG = {
    ...(window.WP_BACKOFFICE_CONFIG || {}),
    ...getEnvConfig(),
  };
  // Mirror login config for convenience
  if (!window.APP_LOGIN_CONFIG) {
    window.APP_LOGIN_CONFIG = {
      user: window.WP_BACKOFFICE_CONFIG.loginUser || '',
      password: window.WP_BACKOFFICE_CONFIG.loginPassword || ''
    };
  }
  if (!window.RUNTIME_CONFIG) {
    window.RUNTIME_CONFIG = {
      apiBaseUrl: window.WP_BACKOFFICE_CONFIG.apiBaseUrl || envCfg.apiBaseUrl || ''
    };
  }
}
